import { IsOptional } from 'class-validator';
import { EpimsBaseEntityDto } from './epim-base.dto';
export class PipelineSectionDto extends EpimsBaseEntityDto {
  
  PipelineSectionId: string;
  AutoSerialId: string;
  PipelineSectionName: string;
  AssetStatusId: string;
  NetworkId: string;
  PigibilityId: string;
  IpStatusId: string;
  LicenceStatusId: string;
  PipelineGradeId: string;
  DeliveryTypeId: string;
  LengthUOMId: string;
  @IsOptional()
  LengthUOMName: string;
  Length: number;
  DiameterUOMId: string;
  @IsOptional()
  DiameterUOMName: string;
  Diameter: number;
  WallThicknessUOMId: string;
  @IsOptional()
  WallThicknessUOMName: string;
  WallThickness: number;
  DesignedPressureUOMId: string;
  @IsOptional()
  DesignedPressureUOMName: string;
  DesignedPressure: number;
  Remarks: string;
  PipelineAssetLocationId: string;
  TerrainId: string;
  @IsOptional()
  TerrianName: string;
  SubscriberId: string;
  SubscriptionUserId: string;
  length;

}